<template>
  <el-row>
    <el-col :span="24">
      <h3>Approval Rules</h3>
      <transition name="panel">
        <div class="pea-panel .rules-panel">
          <div>
            <el-radio v-model="radio" label="Active">Show Active Records</el-radio>
            <el-radio v-model="radio" label="Inactive">Show Inactive Records</el-radio>
            <el-radio v-model="radio" label="Both">Show All Records</el-radio>

            <el-row :gutter="20">
              <el-col :lg="6">
                Division: <all-division-dropdown :clearable="true" v-model="divisionId" :inputModel="divisionId" ref="divisionDropdown"></all-division-dropdown>
              </el-col>
              <el-col :lg="6" style="padding: 10px; margin-top: 13px;">
                <el-button type="primary" icon="el-icon-download" @click="exportToExcel" :disabled="!authorizationRules.length" >
              Export
            </el-button>
              </el-col>
            </el-row>
          </div>
          <el-table :data="authorizationRules" @cell-click="selectRow" @sort-change="sortChange" class="allRulesTable" v-loading="tableLoading">
            <!--@current-change="selectRow"-->
             <el-table-column property="id" align="left"
                             label="ID" sortable="custom">
            </el-table-column>
            <el-table-column property="level" align="left"
                             label="Level" sortable="custom">
            </el-table-column>
            <el-table-column prop="isActive" label="Active" sortable="custom">
              <template slot-scope="scope">
                <span v-if="scope.row.isActive">Yes</span>
                <span v-else>No</span>
              </template>
            </el-table-column>
            <el-table-column prop="peaDivisions" class="divisionCol" align="left"
                             label="Divisions" sortable="custom">
              <template slot-scope="scope">
                <el-button type="text" @click="fetchDivision(scope.row.id)">View Divisions</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="pEARoleDesc" align="left"
                             label="Role" sortable="custom">
            </el-table-column>
            <el-table-column prop="greaterThanNet" label="Cost Greater Than" align="left" sortable="custom">
              <template slot-scope="scope">
                $ {{ formatMoney(scope.row.greaterThanNet)}}
              </template>
            </el-table-column>
            <el-table-column prop="lessThanNet" label="Cost Less Than" align="left" sortable="custom">
              <template slot-scope="scope">
                $ {{ formatMoney(scope.row.lessThanNet)}}
              </template>
            </el-table-column>
            <el-table-column prop="peaFinancialAssetClassifications" align="left"
                             label="Asset" sortable="custom">
              <template slot-scope="scope">
                <el-button type="text" @click="fetchAsset(scope.row.id)">View Assets</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="ruleDescription" align="left"
                             label="Rule" sortable="custom">
              <template slot-scope="scope">
                <tool-tip-popup :text="scope.row.ruleDescription">
                </tool-tip-popup>
              </template>

            </el-table-column>
          </el-table>
          <el-pagination v-if="resultTotal > pageSize"
                         @current-change="fetchDataByFilterAndOrder(radio, divisionId, column, order)"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="total, prev, pager, next"
                         :total="resultTotal">
          </el-pagination>
          <el-dialog title="Divisions"
            :visible.sync="divisionsVisible"
            width="50%">
            <div v-loading="divIsLoading">
              <ul>
                <li v-for="ruleDivision in ruleDivisions" v-bind:key="ruleDivision.id">{{ ruleDivision.name }}</li>
              </ul>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="divisionsVisible = false">Close</el-button>
            </span>
          </el-dialog>
          <el-dialog title="Financial Asset Classifications"
            :visible.sync="assetVisible"
            width="50%">
            <div v-loading="assetIsLoading">
              <ul>
                <li v-for="ruleAsset in ruleAssets" v-bind:key="ruleAsset.id">{{ ruleAsset.description }}</li>
              </ul>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="assetVisible = false">Close</el-button>
            </span>
          </el-dialog>
        </div>
      </transition>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
import router from '@/router'
export default {
  name: 'PEAApprovalRolesAndRules',
  data () {
    return {
      authorizationRules: [],
      ruleDivisions: [],
      divIsLoading: true,
      ruleAssets: [],
      assetIsLoading: true,
      currentPage: 1,
      pageSize: 6,
      resultTotal: 0,
      tableLoading: true,
      radio: 'Active',
      column: 'Level',
      order: 'Ascending',
      divisionId: '',
      divisionsVisible: false,
      assetVisible: false
    }
  },
  methods: {
    fetchDataByFilterAndOrder: function (filter, divId, column, direction) {
      if (filter === 'Active' || filter === 'Inactive' || filter === 'Both') {
        this.tableLoading = true
        var call = '/getPEARuleList/' + '?page=' + this.currentPage + '&pageSize=' + this.pageSize + '&filterMode=' + filter + '&divisionId=' + divId + '&sortColumn=' + column + '&sortOrder=' + direction
        this.$axios.get(call).then(response => {
          this.authorizationRules = response.data.results
          this.resultTotal = response.data.totalRecords
          this.tableLoading = false
          this.radio = filter
          this.divisionId = divId
          this.column = column
          this.direction = direction
        }).catch(reject => {
          this.tableLoading = false
          this.tableData = null
          this.resultTotal = 0
        })
      }
    },
    fetchDivision: function (ruleId) {
      this.divIsLoading = true
      var call = '/getPEARuleDivisions/' + ruleId
      this.$axios.get(call).then(response => {
        this.ruleDivisions = response.data
        this.divisionsVisible = true
        this.divIsLoading = false
      }).catch(reject => {
        this.divisionsVisible = false
        this.divIsLoading = false
        this.ruleDivisions = null
      })
    },
    fetchAsset: function (ruleId) {
      this.assetIsLoading = true
      var call = '/getPEARuleAssets/' + ruleId
      this.$axios.get(call).then(response => {
        this.ruleAssets = response.data
        this.assetVisible = true
        this.assetIsLoading = false
      }).catch(reject => {
        this.assetVisible = false
        this.assetIsLoading = false
        this.ruleAssets = null
      })
    },
    sortChange: function (col) {
      this.column = col.prop
      this.order = col.order
      this.fetchDataByFilterAndOrder(this.radio, this.divisionId, col.prop, col.order)
    },
    exportToExcel () {
      import('exceljs').then(ExcelJS => {
        const fetchAllRulesUrl =
          '/getPEARuleList/?page=1&pageSize=100' +
          `&filterMode=${this.radio}` +
          `&divisionId=${this.divisionId}` +
          `&sortColumn=${this.column}` +
          `&sortOrder=${this.order}`

        this.$axios.get(fetchAllRulesUrl).then(response => {
          const rules = response.data.results || []
          const grouped = {}

          rules.forEach(rule => {
            const approver = rule.pEARoleDesc || 'Unknown Approver'
            const description = rule.ruleDescription || ''
            if (!grouped[approver]) grouped[approver] = []
            if (!grouped[approver].includes(description)) {
              grouped[approver].push(description)
            }
          })

          let divisionName = 'All Divisions'
          const divisions = (this.$refs.divisionDropdown && this.$refs.divisionDropdown.divisionList) || []
          const match = divisions.find(d => Number(d.id) === Number(this.divisionId))
          if (match) divisionName = match.name

          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Approval Rules')

          // Title row for division
          worksheet.addRow([`Division: ${divisionName}`])
          worksheet.getRow(1).font = { bold: true, size: 20 }
          worksheet.addRow([])

          let rowNumber = 3
          let approverIndex = 1
          for (const approver in grouped) {
            const titleRow = worksheet.getRow(rowNumber++)
            titleRow.getCell(1).value = `${approverIndex}. Approval Role: ${approver}`
            titleRow.getCell(1).font = { bold: true }

            const subtitleRow = worksheet.getRow(rowNumber++)
            subtitleRow.getCell(1).value = 'Can approve the following rule(s):'
            subtitleRow.getCell(1).font = { italic: true, size: 10 }

            grouped[approver].forEach(rule => {
              const ruleRow = worksheet.getRow(rowNumber++)
              ruleRow.getCell(1).value = `• ${rule}`
            })

            worksheet.addRow([])
            rowNumber++
            approverIndex++
          }

          const fileName = `approval_rules_${divisionName.replace(/\s+/g, '_')}.xlsx`
          workbook.xlsx.writeBuffer().then(data => {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = fileName
            a.click()
            window.URL.revokeObjectURL(url)
          })
        }).catch(err => {
          console.error('Failed to fetch rules for export:', err)
        })
      })
    },

    selectRow: function (row, column, cell, event) {
      if (cell.innerHTML.toString().indexOf('Divisions') === -1 && cell.innerHTML.toString().indexOf('Asset') === -1) {
        if (this.$store.getters.isAdmin) {
          router.push('changeApprovalRule/' + row.id)
        }
      }
    },
    formatMoney: function (money) {
      if (money !== null) {
        return helperMethods.formatMoney(parseFloat(money))
      }
    },
    startUp () {
      this.fetchDataByFilterAndOrder(this.radio, this.divisionId, this.column, this.order)
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    radio: function () {
      this.fetchDataByFilterAndOrder(this.radio, this.divisionId, this.column, this.order)
    },
    divisionId: function () {
      this.fetchDataByFilterAndOrder(this.radio, this.divisionId, this.column, this.order)
    }
  }
}
</script>

<style scoped>
  h4 {
    margin-bottom: 20px;
  }

  .rules-panel {
    padding-bottom: 30px;
  }
</style>
<style>
  .allRulesTable tr:hover {
    cursor: pointer;
  }
</style>
